import { AlertResponse } from '@/app/types/alertType'
import { apiSlice } from './apiSlice'
import { toast } from 'sonner'

export const alertSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAlerts: builder.query({
      query: (data: { page: number; order?: string }) =>
        `/buyer_alerts?per_page=5&page=${data.page}&order=${data.order ?? 'desc'}`,
      providesTags: ['Alerts'],
      transformResponse: async (responseData) => {
        return responseData
      },
    }),

    addAlerts: builder.mutation({
      query: (alerts: FormData) => ({
        url: '/buyer_alerts',
        method: 'POST',
        body: alerts,
      }),
      invalidatesTags: ['Alerts'],
      transformResponse: async (responseData: AlertResponse) => {
        return responseData.status
      },
      transformErrorResponse: async (responseData: any) => {
        toast.error(responseData?.data?.errors)
        return responseData
      },
    }),
    editAlerts: builder.mutation({
      query: (data: { id: number | null; alerts: FormData }) => ({
        url: `/buyer_alerts/${data.id}`,
        method: 'PATCH',
        body: data.alerts,
      }),
      invalidatesTags: ['Alerts'],
      transformResponse: async (responseData: AlertResponse) => {
        return responseData.status
      },
      transformErrorResponse: async (responseData: any) => {
        toast.error(responseData?.data?.errors)
        return responseData
      },
    }),
    getSingleAlert: builder.query({
      query: (id: number | string | null) => `/buyer_alerts/${id}`,
      transformResponse: async (responseData) => {
        return responseData
      },
    }),
    deleteAlert: builder.mutation({
      query: (id) => ({
        url: `/buyer_alerts/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Alerts'],
      transformResponse: async (responseData) => {
        return responseData
      },
    }),
    getRelatedAlert: builder.query({
      query: (id: string | number | null) => `/buyer_alerts/${id}/related`,
      transformResponse: async (responseData) => {
        return responseData
      },
    }),
    getSuggestedAlert: builder.query({
      query: () => `/buyer_alerts/suggestions`,
      transformResponse: async (responseData) => {
        return responseData
      },
    }),
  }),
})

export const {
  useGetAlertsQuery,
  useAddAlertsMutation,
  useEditAlertsMutation,
  useGetSingleAlertQuery,
  useDeleteAlertMutation,
  useGetRelatedAlertQuery,
  useGetSuggestedAlertQuery,
} = alertSlice
